import React, { useRef } from 'react'
import {
    Text,
    TextProps,
    Tooltip,
    useClipboard,
    useToast,
} from '@chakra-ui/react'

const ClickToCopyText: React.FC<
    TextProps & { copyOverride?: string; isDisabled?: boolean }
> = ({ children, copyOverride, isDisabled, ...props }) => {
    const textRef = useRef<HTMLParagraphElement | null>(null)
    const { onCopy } = useClipboard(
        copyOverride || textRef.current?.innerText || '',
    )

    const toast = useToast({
        title: 'Copied',
        duration: 600,
        position: 'top',
    })

    return (
        <Tooltip
            isDisabled={isDisabled}
            label="Click to copy"
            openDelay={500}
            placement="right"
            hasArrow
            bg="white"
            borderColor="blackAlpha.200"
            borderWidth={1}
            fontSize="12px"
            color="gray.700"
        >
            <Text
                ref={textRef}
                display="block"
                onClick={
                    !isDisabled
                        ? () => {
                              onCopy()
                              toast()
                          }
                        : () => {}
                }
                _hover={
                    !isDisabled
                        ? { cursor: 'pointer', textDecoration: 'underline' }
                        : {}
                }
                {...props}
            >
                {children}
            </Text>
        </Tooltip>
    )
}

export default ClickToCopyText
